import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import {
  SET_VIDEO_IS_CLICKED,
  CLEAR_VIDEO_IS_CLICKED,
} from 'actions/clickedVideo';

const INITIAL_STATE = Immutable({
  videoId: null,
  rowTitle: null,
  rowPos: null,
  rowCol: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_VIDEO_IS_CLICKED:
      return state.merge({
        videoId: action.payload.videoId,
        rowTitle: action.payload.rowTitle,
        rowPos: action.payload.rowPos,
        rowCol: action.payload.rowCol,
      });
    case CLEAR_VIDEO_IS_CLICKED:
      return state.merge({
        videoId: null,
        rowTitle: null,
        rowPos: null,
        rowCol: null,
      });
    default:
      return state;
  }
};
